var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initMainSearch = /* @__PURE__ */ __name(($el, type, current_sort) => {
  var _a, _b, _c;
  const state = window.Alpine.reactive({
    loading: false,
    types: new Set(type.split(",")),
    count: (_b = (_a = $el.querySelector("[data-next-url]")) == null ? void 0 : _a.children) == null ? void 0 : _b.length,
    sort_by: current_sort,
    next_url: (_c = $el.querySelector("[data-next-url]")) == null ? void 0 : _c.getAttribute("data-next-url")
  });
  const modalStore = window.Alpine.store("modal");
  const search = window.Alpine.store("search");
  Alpine.effect(() => {
    if (state.sort_by !== current_sort) {
      Alpine.nextTick(() => {
        updateSortAndFilters();
      });
    }
  });
  const updateSortAndFilters = /* @__PURE__ */ __name(async (url = new URL(`${((_d) => (_d = $el.action) == null ? void 0 : _d.split("?")[0])()}?${new URLSearchParams(new FormData($el)).toString()}`)) => {
    var _a2, _b2, _c2, _d2, _e, _f;
    modalStore.setId("");
    state.loading = true;
    (_a2 = document == null ? void 0 : document.querySelectorAll(
      "form[data-search-form] :where([class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--])"
    )) == null ? void 0 : _a2.forEach((card) => {
      var _a3;
      (_a3 = card == null ? void 0 : card.classList) == null ? void 0 : _a3.add("button-loading-transparent");
    });
    const content = await fetch(url).then((res) => res.text());
    (_b2 = url == null ? void 0 : url.searchParams) == null ? void 0 : _b2.delete("barba_prefetch");
    barba.history.add(url.toString(), "barba", "replace");
    const newDocument = document.createElement("div");
    newDocument.innerHTML = content;
    document.querySelectorAll("form[data-search-form]").forEach((oldForm) => {
      const section = newDocument.querySelector(`[data-style-id="${oldForm.getAttribute("data-style-id")}"]`);
      oldForm.outerHTML = section.outerHTML;
    });
    state.loading = false;
    state.count = (_d2 = (_c2 = $el.querySelector("[data-next-url]")) == null ? void 0 : _c2.children) == null ? void 0 : _d2.length;
    const header = document.querySelector(".header-sections-container");
    const offsetHeight = Math.max(180, (_f = (_e = header == null ? void 0 : header.getBoundingClientRect()) == null ? void 0 : _e.bottom) != null ? _f : 0);
    utils.scrollToY(150, utils.getElementPosition($el).top - offsetHeight - +getComputedStyle($el).paddingTop.replace("px", ""));
  }, "updateSortAndFilters");
  const debounceUpdates = utils.debounce(updateSortAndFilters, 750);
  const loadNextPage = /* @__PURE__ */ __name(async (container = $el.querySelector(`[data-next-url]`), paginationContainer = $el.querySelector(`[data-pagination][x-ref="pagination"]`)) => {
    var _a2;
    if (!state.next_url || state.loading) return;
    state.loading = true;
    const html = await fetch(state.next_url).then((res) => res.text());
    const newDocument = document.createElement("div");
    newDocument.innerHTML = html;
    const section = newDocument.querySelector(`[data-style-id="${$el.getAttribute("data-style-id")}"]`);
    const newContent = section.querySelector(`[data-next-url][x-ref="${container == null ? void 0 : container.getAttribute("x-ref")}"]`);
    state.next_url = newContent == null ? void 0 : newContent.getAttribute("data-next-url");
    const newPagination = section.querySelector(`[data-pagination][x-ref="pagination"]`);
    if (newContent) {
      container.append(...newContent.children);
      state.count = (_a2 = container == null ? void 0 : container.children) == null ? void 0 : _a2.length;
    }
    if (paginationContainer && newPagination) {
      paginationContainer.innerHTML = newPagination.innerHTML;
    }
    state.loading = false;
  }, "loadNextPage");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "always": {
        return true;
      }
      case "no_search_query":
        return !search.query;
      case "with_search_query":
        return !!search.query;
      case "search_empty": {
        return state.count <= 0;
      }
      case "items_found": {
        return state.count > 0;
      }
    }
  }, "showConditionally");
  return {
    main_search: {
      state,
      loadNextPage,
      updateSortAndFilters,
      debounceUpdates,
      showConditionally
    }
  };
}, "initMainSearch");
window._sections["initMainSearch"] = initMainSearch;
